import React, { useEffect } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";

const PaymentSuccess: React.FC = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const resultData: Record<string, string> = {};
    params.forEach((value, key) => {
      resultData[key] = value;
    });

    if (window.parent && window.parent !== window) {
      window.parent.postMessage(
        {
          type: "TRANZILA_PAYMENT_SUCCESS",
          data: resultData,
        },
        window.location.origin
      );
    }
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        minHeight: "350px",
        p: 3,
        textAlign: "center",
      }}
    >
      <CircularProgress color="success" size={48} />
      <Typography variant="body1" sx={{ mt: 2, fontWeight: 500 }}>
        התשלום עבר בהצלחה, מעביר לאישור...
      </Typography>
    </Box>
  );
};

export default PaymentSuccess;